// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"606c0471","787":"0edb8459"}[chunkId] + ".chunk.js";
};